import { request } from "../../utils/axios";

export const fetchSurvey = async (id: number) => {
  try {
    const res = await request.get(`surveys/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const submitResponse = async (form: {
  id: number;
  answers: Record<number, string>;
}) => {
  try {
    const res = await request.post(`surveys/${form.id}/responses`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
